import { SVGProps } from 'react';

const CornerUpLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M20 20v-7a4 4 0 0 0-4-4H4m5-5L4 9l5 5"
    />
  </svg>
);
export default CornerUpLeft;
